import { useQuizContext } from '../context';

export function useAnswers() {
  const ctx = useQuizContext();

  return ctx.answers;
}
